import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentIdol } from "@/shared/store/slices/userSlice";
import { markPageUnloading } from "@/shared/api/axios";
import { persistor } from "@/shared/store/store";

import IdolPickList from "@/components/ui/IdolPickList";

import { Card, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// 登入後選擇偶像；沒有可用（未停權）的偶像時改為引導創建偶像
function LoginIdols({ onCreateIdol }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const idolList = useSelector((state) => state.idol.list);

  const hasAvailableIdol = idolList.some((idol) => !idol.idol_is_suspended);

  // 選完偶像整頁導向首頁（比照 navbar 切換偶像）：登入頁本身就在 "/"，SPA 導向路徑不變，
  // App 依 pathname 觸發的聊天室列表／通知抓取與聊天 WS 訂閱都不會執行，要等下一次換頁才補上
  const handlePickIdol = async (idol) => {
    dispatch(setCurrentIdol(idol));
    // redux-persist 是非同步寫入，整頁跳轉前必須先 flush，否則重載後會 rehydrate 回未選偶像的狀態
    await persistor.flush();
    markPageUnloading();
    window.location.href = "/";
  };

  return (
    <>
      <Card.Title className="loginbox-title text-center border-bottom">
        <h2 className="p-3">{t("choose_persona")}</h2>
      </Card.Title>
      <Card.Body className="py-3 pb-4 px-4">
        <IdolPickList idols={idolList} onPick={handlePickIdol} />
        {!hasAvailableIdol && (
          <Button className="btn btn-primaryF w-100 mt-4" onClick={onCreateIdol}>
            <FontAwesomeIcon icon={["fas", "plus"]} className="me-2" />
            {t("create_idol")}
          </Button>
        )}
      </Card.Body>
    </>
  );
}

LoginIdols.propTypes = {
  onCreateIdol: PropTypes.func.isRequired,
};

export default LoginIdols;
